import { render, staticRenderFns } from "./icon-profile.vue?vue&type=template&id=1f5182e8&scoped=true&"
import script from "./icon-profile.vue?vue&type=script&lang=js&"
export * from "./icon-profile.vue?vue&type=script&lang=js&"
import style0 from "./icon-profile.vue?vue&type=style&index=0&id=1f5182e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5182e8",
  null
  
)

export default component.exports